import React from 'react';
import {Card, Divider, Flex} from "antd";
import Header from "./Header";
import {ContentCard} from "./Header.styled";

const TermsOfService = () => {
    return (

            <Flex vertical>
                <Header/>
                <ContentCard >
                    <h3>سیاست‌نامه حریم خصوصی پلتفرم آنلاین اجاره تجهیزات و لوازم « پیدا »</h3>

                    <h4>مقدمه</h4>
                    <p>پلتفرم آنلاین اجاره تجهیزات و لوازم « پیدا » به حریم خصوصی کاربران خود اهمیت ویژه‌ای می‌دهد و
                        متعهد است
                        که اطلاعات شخصی ارائه‌شده توسط شما را با رعایت قوانین جاری و به‌منظور بهبود خدمات و ارتقای سطح
                        امنیت
                        مدیریت کند. استفاده از سامانه به منزله پذیرش کامل مفاد این سند تلقی می‌شود؛ لذا لطفاً پیش از
                        استفاده به
                        دقت مطالعه نمایید.</p>

                    <h3>۱. اطلاعات جمع‌آوری‌شده از کاربران</h3>

                    <h4>اطلاعات حساب کاربری:</h4>
                    <p>در زمان ثبت‌نام، کاربران موظف به ارائه اطلاعات هویتی از جمله شماره تلفن همراه، ایمیل و سایر
                        داده‌های
                        مرتبط هستند.<br/>
                        این اطلاعات به صورت امن ذخیره شده و در پروفایل عمومی نمایش داده نمی‌شود.</p>

                    <h4>اطلاعات مربوط به فعالیت در سامانه:</h4>
                    <p>هرگونه بازدید، بارگذاری آگهی، ثبت نظرات و استفاده از امکانات سامانه، جهت بهبود خدمات و پیشگیری از
                        تخلفات،
                        ثبت و ذخیره می‌شود.</p>

                    <h4>اطلاعات فنی:</h4>
                    <p>جهت ارتقای عملکرد و پشتیبانی بهتر، داده‌های فنی مانند آدرس IP، نوع و مدل دستگاه، سیستم عامل، نوع
                        و نسخه
                        مرورگر، زمان و تاریخ دسترسی و سایر اطلاعات مرتبط جمع‌آوری می‌گردد.</p>

                    <h4>کوکی‌ها:</h4>
                    <p>سامانه از کوکی‌ها برای شناسایی ترجیحات شما و ارائه محتوای متناسب بهره می‌برد.<br/>
                        با استفاده از سامانه، شما با ذخیره و استفاده از کوکی‌ها موافقت می‌کنید. می‌توانید از طریق
                        تنظیمات مرورگر
                        کوکی‌ها را غیرفعال کنید؛ اما در این صورت ممکن است برخی امکانات به‌درستی عمل نکنند.</p>

                    <h4>اطلاعات مکالمات و نظرسنجی‌ها:</h4>
                    <p>جهت بهبود خدمات پشتیبانی و افزایش کیفیت تجربه کاربری، مکالمات شما با تیم پشتیبانی و پاسخ‌های
                        نظرسنجی ثبت
                        و ذخیره می‌شود.</p>

                    <h3>۲. اشتراک‌گذاری اطلاعات</h3>
                    <p>اطلاعات شخصی شما تنها در صورت دریافت دستور قانونی از مراجع ذی‌صلاح و در چارچوب قوانین جاری به
                        آن‌ها ارائه
                        می‌شود.<br/>
                        همچنین، برای اهداف فنی، امنیتی و بهبود خدمات، ممکن است داده‌های شما به شرکای معتبر و وابسته به
                        سامانه
                        منتقل شود؛ اما این اطلاعات صرفاً برای اهداف مذکور استفاده شده و به هیچ عنوان جهت تبلیغات شخص
                        ثالث در
                        اختیار آنان قرار نخواهد گرفت.</p>

                    <h3>۳. امنیت اطلاعات</h3>
                    <p>انتقال اطلاعات در سامانه با استفاده از فناوری رمزگذاری SSL انجام می‌شود تا از دسترسی‌های غیرمجاز
                        جلوگیری
                        شود.<br/>
                        ورود به حساب کاربری با استفاده از رمز عبور یک‌بار مصرف (OTP) صورت می‌گیرد که اطمینان از دسترسی
                        تنها با
                        شماره تلفن ثبت‌شده را فراهم می‌کند.<br/>
                        اطلاعات حساس مربوط به پرداخت‌ها از طریق درگاه‌های بانکی معتبر پردازش شده و در سامانه ذخیره
                        نمی‌شود.</p>

                    <h3>۴. نگهداری اطلاعات</h3>
                    <p>اطلاعات جمع‌آوری‌شده مطابق با قوانین موجود، برای مدت زمان لازم جهت ارائه خدمات و رعایت الزامات
                        قانونی
                        نگهداری می‌شود.<br/>
                        پس از عدم استفاده یا لغو حساب کاربری، اطلاعات بر اساس مقررات مربوطه حذف یا بایگانی می‌گردد.</p>

                    <h3>۵. تغییرات در سیاست‌نامه</h3>
                    <p>سامانه ممکن است به‌روزرسانی‌هایی در این سیاست‌نامه اعمال کند. استفاده مستمر شما از سامانه پس از
                        اعلام
                        تغییرات، به منزله پذیرش مفاد جدید تلقی می‌شود.</p>

                    <h3>۶. ارتباط با ما</h3>
                    <p>در صورت هرگونه سوال، پیشنهاد یا نیاز به اطلاعات بیشتر درباره سیاست حریم خصوصی، می‌توانید از طریق
                        بخش
                        پشتیبانی سامانه یا تماس‌های اعلام‌شده با ما در ارتباط باشید.</p>
<Divider/>
                    <p>این سیاست‌نامه با هدف تضمین یک فضای امن و شفاف جهت استفاده از سامانه اجاره تجهیزات پیدا تنظیم شده
                        است.<br/>
                        ما همواره در تلاشیم تا با به‌روزرسانی‌های لازم، سطح حفاظت از اطلاعات شما را بهبود بخشیم و
                        تجربه‌ای
                        رضایت‌بخش برای شما فراهم آوریم.</p>
                </ContentCard>

            </Flex>


    );
};

export default TermsOfService;